import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import BaseLayout from "../../../components/layouts/BaseLayout";
import VehicleIncident from "./VehicleIncident";
import { createIncident } from "../../../apiCalls/admin/vehicleIncidents";
import { setAlert } from "../../../redux/actions/actions";
import { RootStateInterface } from "../../../interfaces/ReduxInterface";

const VehicleIncidentCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const currentCustomer = useSelector(
    (state: RootStateInterface) => state.customer.currentCustomer,
  );
  const defaultIncident = {
    damages: [],
  };

  const handleCancel = () => {
    history.push("/admin/fleet/incidents");
  };

  const handleSave = (incident) => {
    const data = {
      vehicle_id: incident.vehicle_id,
      damages: incident.damages || [],
    };
    createIncident(currentCustomer?.shortname, data)
      .then(handleCancel)
      .catch(() => dispatch(setAlert("An error occurred", "error")));
  };

  return (
    <BaseLayout title="Create incident" handleArrowClick={handleCancel}>
      <VehicleIncident
        initialIncident={defaultIncident}
        handleCancel={handleCancel}
        handleSave={handleSave}
      />
    </BaseLayout>
  );
};

export default VehicleIncidentCreate;
